import client from "./client";

export interface EmailTemplate {
  id: string;
  org_id: string;
  template_key: string;
  subject: string;
  body: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  is_default: boolean;
  available_variables: string[];
}

export async function listEmailTemplates(): Promise<EmailTemplate[]> {
  const res = await client.get<EmailTemplate[]>("/email-templates");
  return res.data;
}

export async function getEmailTemplate(key: string): Promise<EmailTemplate> {
  const res = await client.get<EmailTemplate>(`/email-templates/${key}`);
  return res.data;
}

export async function updateEmailTemplate(
  key: string,
  patch: { subject?: string; body?: string; is_active?: boolean },
): Promise<EmailTemplate> {
  const res = await client.put<EmailTemplate>(
    `/email-templates/${key}`,
    patch,
  );
  return res.data;
}

export async function resetEmailTemplate(
  key: string,
): Promise<EmailTemplate> {
  const res = await client.post<{ template: EmailTemplate }>(
    `/email-templates/${key}/reset`,
  );
  return res.data.template;
}

export async function previewEmailTemplate(
  key: string,
  payload: {
    subject?: string;
    body?: string;
    variables?: Record<string, string>;
  },
): Promise<{ subject: string; body: string }> {
  const res = await client.post(`/email-templates/${key}/preview`, payload);
  return res.data;
}
